/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  axios,
  AxiosResponsePromise,
  AxiosRequestExtraConfig,
  AxiosRequestConfig,
} from '@seiue/axios'
import {
  createConfigBuilder,
  useQueryApi,
  useMutationApi,
  UseQueryApiReturns,
} from '../utils'
import { MutationOptions, QueryOptions, Expand } from '../types'
import { FileDirName } from './file-dir-name'
import { TokenRes } from './token-res'
import { UploadFile } from './upload-file'
import { Upload } from './upload'

const buildConfig = createConfigBuilder('growp')

export const fileApi = {
  getOssSignatureConfig(
    ext: string,
    dirname: FileDirName,
    options?: AxiosRequestExtraConfig
  ): AxiosRequestConfig {
    return buildConfig(options, 'get', '/file/getOssSignature', {
      ext,
      dirname,
    })
  },

  /**
   * @summary 获取api方式上传文件签名
   * @param ext
   * @param dirname
   * @param [options]
   * @return AxiosResponsePromise<TokenRes>
   */
  getOssSignature(
    ext: string,
    dirname: FileDirName,
    options?: AxiosRequestExtraConfig
  ): AxiosResponsePromise<TokenRes> {
    return axios(fileApi.getOssSignatureConfig(ext, dirname, options)).then(
      ({ data: _data, ...rest }) => {
        const data = _data ? new TokenRes(_data) : _data
        return { data, ...rest }
      }
    ) as any
  },

  useGetOssSignature(
    {
      ext,
      dirname,
    }: {
      ext: string
      dirname: FileDirName
    },
    queryOptions?: QueryOptions
  ): UseQueryApiReturns<TokenRes> {
    return useQueryApi<TokenRes>(
      fileApi.getOssSignature,
      'File.getOssSignature',
      queryOptions,
      ext,
      dirname
    )
  },

  fileUploadConfig(
    name: string,
    uploadFile: UploadFile,
    options?: AxiosRequestExtraConfig
  ): AxiosRequestConfig {
    return buildConfig(
      options,
      'post',
      '/file/upload',
      {
        name,
      },
      null,
      uploadFile,
      {
        format: 'form',
        isArray: false,
        defaults: {},
      }
    )
  },

  /**
   * @summary 文件上传
   * @param name
   * @param uploadFile
   * @param [options]
   * @return AxiosResponsePromise<Upload>
   */
  fileUpload(
    name: string,
    uploadFile: UploadFile,
    options?: AxiosRequestExtraConfig
  ): AxiosResponsePromise<Upload> {
    return axios(fileApi.fileUploadConfig(name, uploadFile, options)).then(
      ({ data: _data, ...rest }) => {
        const data = _data ? new Upload(_data) : _data
        return { data, ...rest }
      }
    ) as any
  },

  useFileUpload(mutationOptions?: MutationOptions) {
    return useMutationApi(
      ({ name, payload }: { name: string; payload: UploadFile }) =>
        fileApi.fileUpload(name, payload),
      mutationOptions
    )
  },
}

// generate uuid for every api function, useful for result-caching & other things
Object.keys(fileApi).forEach((api) => {
  // @ts-ignore
  fileApi[api]._name_ = `File.${api}`
})
